import React, { useState } from "react";
import { getToken } from "../../utils/common";
import { PomTestData } from "../../typings/pom";
import Button from "../UI/Button";
import { Download, AlertCircle, Loader2 } from "lucide-react";

interface PomPdfDownloadProps {
  testId: number;
  testData?: PomTestData;
  studentName?: string;
}

const PomPdfDownload: React.FC<PomPdfDownloadProps> = ({
  testId,
  testData,
  studentName,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async () => {
    setIsDownloading(true);
    setError(null);

    try {
      const token = getToken();

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/pom/download-pdf/${testId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            testId,
            studentName: studentName,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to download PDF");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `TOP-Result-${testId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Gagal mengunduh PDF");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="pom-pdf-download w-full">
      <Button
        block
        className="gradient-accent text-white font-bold"
        onClick={handleDownload}
        disabled={isDownloading}
      >
        {isDownloading ? (
          <>
            <Loader2 className="animate-spin w-4 h-4 mr-2" />
            Mengunduh...
          </>
        ) : (
          <>
            <Download className="w-4 h-4 mr-2" /> Download Laporan PDF
          </>
        )}
      </Button>

      {error && (
        <div className="p-3 rounded-lg border bg-amber-50 border-amber-200 text-amber-800 mt-2 flex items-center gap-2">
          <AlertCircle className="w-4 h-4 flex-shrink-0" />
          <small className="font-medium text-xs">File PDF sedang disiapkan. Silakan coba lagi dalam beberapa saat.</small>
        </div>
      )}
    </div>
  );
};

export default PomPdfDownload;
